import { useAppSelector } from '../index';
import { openTicketsSelector } from '@ogsnetwork/opp-redux-lib';
export function useTicketFromEvent(props) {
    const tickets = useAppSelector((state) => openTicketsSelector(state));
    const ticket = tickets.find((ticket) => ticket.eventId === props.event.id);
    return {
        ticket
    };
}
